import { useContext, useState, useEffect } from 'react';
import { canvasOption } from '@intelligence/utils/radiusImg';
import ConsoleGameDefault from '@intelligence/assets/imgs/common/consolegame-default.png';
import GameDefault from '@intelligence/assets/imgs/common/game-default.svg';
import { formatNum } from '@intelligence/utils/commonUtils';
import { ECHARTSCOLOR, BAR_COLORS } from '@intelligence/utils/echartsConst';
import {
  AnnieTiaoEchartImg,
  DatabrainHuiEchartImg,
  SensorTowerNormalEchartImg,
  SensorTowerDianEchartImg,
} from '@intelligence/pages/TopCharts/_config/base64Img';
import ChartBubble from '@intelligence/components/ChartBubble';
import {
  BAR_GRID_TOP_WITH_LABEL,
  BAR_GRID_BOTTOM_WITH_RICH_IMG,
  LEGEND_BOTTOM,
} from '@intelligence/pages/TopCharts/_config/echarts';
import { ThemeContext } from '@home/wrappers/common';

export default function useMultiDataSourceBarCharts(props: any) {
  const {
    sendEchartsData,
    loading,
    dataSourceEachers,
    isDataBrain = false,
    lenten,
    titleNow = '',
    topChartsType,
    startDate,
    endDate,
    isStudio = false,
    gameHighId = '',
  } = props;

  // console.log('useActiveUserBarCharts', props);

  // 获取颜色主题值，通过ThemeContext消费者useContext
  const { themeValue } = useContext(ThemeContext);
  // 柱状图的数据
  const [BarEcharts, setBarEcharts] = useState<any>(null);
  const [barOption, setBarOption] = useState<any>(null);
  const [showBarPeiName, setShowBarPeiName] = useState<any>([]);
  const [axisRich, setAxisRich] = useState({});

  useEffect(() => {
    waitCavas(lenten, themeValue);
  }, [lenten, themeValue]);

  const waitCavas = async (lenten: any[], themeValue: boolean) => {
    const xAxis: any = {};
    const imageUrl: any = {};
    lenten?.map((item: { name: any; imageUrl: any }, index: any) => {
      imageUrl[item.name] = item.imageUrl || ConsoleGameDefault;
    });

    const iconOption: any = await canvasOption(imageUrl, 51.2, 51.2, 8, themeValue, false);

    lenten?.forEach((item: { id: any; name: string | number }) => {
      xAxis[item.id] = {
        backgroundColor: {
          image: iconOption[item.name] ? iconOption[item.name] : GameDefault,
        },
        align: 'center',
        height: 30,
        width: 30,
      };
    });
    setAxisRich({ ...xAxis });
  };

  useEffect(() => {
    if (
      sendEchartsData !== undefined &&
      sendEchartsData !== null &&
      sendEchartsData?.length !== 0 &&
      // 修改判断方式，避免 all of time 数据量过大，导致 JSON.stringify 报错
      // JSON.stringify(sendEchartsData) !== '{}'
      Object.keys(sendEchartsData).length !== 0
    ) {
      PieBarEchartsList();
    }
  }, [sendEchartsData]);

  useEffect(() => {
    if (BarEcharts && !loading && axisRich && JSON.stringify(axisRich) != '{}') handleEchart(dataSourceEachers); // 柱状
  }, [axisRich]);

  // 饼图和柱状图数据结构改变
  const PieBarEchartsList = () => {
    const showLentList: any[] = [];
    const sourceList: any[] = [];
    const setShowBarPeiNameS: any[] = [];
    const pieOther: number[] = [];
    const allNum: any[] = [];
    lenten?.map(
      (
        item: {
          rank_metric: any;
          metric_list: any[];
          metric_value_list: any[];
        },
        index: number,
      ) => {
        setShowBarPeiNameS?.push(item.rank_metric);
        if (item.metric_list) {
          item.metric_list?.map((citem: { source: any }, cindex: any) => {
            if (index === 0) {
              sourceList?.push(citem.source);
              pieOther?.push(0);
              allNum?.push(0);
            }
          });
        } else {
          item?.metric_value_list?.map((citem: { source: any }, cindex: any) => {
            if (index === 0) {
              sourceList?.push(citem.source);
              pieOther?.push(0);
              allNum?.push(0);
            }
          });
        }
      },
    );
    lenten?.map((item: { metric_list: any[]; metric_value_list: any[] }, index: number) => {
      if (item.metric_list) {
        item.metric_list?.map((citem: { value: number }, cindex: any) => {
          allNum[cindex] += citem.value * 1;
          if (index >= 5) {
            pieOther[cindex] += citem.value * 1;
          }
        });
      } else {
        item.metric_value_list?.map((citem: { value: number }, cindex: any) => {
          allNum[cindex] += citem.value * 1;
          if (index >= 5) {
            pieOther[cindex] += citem.value * 1;
          }
        });
      }
    });
    sourceList?.map(() => {
      showLentList?.push([]);
    });
    setShowBarPeiName(setShowBarPeiNameS);
    lenten?.map(
      (
        item: {
          rank_metric: string;
          metric_list: any;
          metric_value_list: any;
          imageUrl: any;
        },
        index: any,
      ) => {
        // const name = item.rank_metric?.length > 30 ? item.rank_metric.slice(0, 29) + '...' : item.rank_metric
        const metricList = item.metric_list || item.metric_value_list;
        metricList?.map((citem: { source: any; value: number }, cindex: any) => {
          const url = item.imageUrl || ConsoleGameDefault;
          showLentList[cindex]?.push({
            url,
            source: citem.source || citem.data_source,
            name: item.rank_metric,
            value: ((citem.value / allNum[cindex]) * 100).toFixed(2),
            barvalue: citem.value,
            color: dataSourceEachers?.length > 1 ? BAR_COLORS[0][index] : ECHARTSCOLOR[index],
            colorRight: BAR_COLORS[1][index],
            colorThird: BAR_COLORS[2][index],
            index:
              dataSourceEachers?.length > 1
                ? BAR_COLORS[0][index].replace('#', '')
                : ECHARTSCOLOR[index].replace('#', ''),
          });
        });
      },
    );
    setBarEcharts(showLentList);
  };

  const getDecal = () => {
    if (topChartsType == 'databrain') {
      return {
        enabled: true,
        decal: {
          show: true,
          decals: [
            {
              symbol: 'none',
            },
            {
              symbol: 'rect',
              color: 'rgba(255, 255, 255, 0.12)',
              dashArrayX: [4, 16],
              dashArrayY: [1, 0],
              rotation: 45,
            },
            {
              symbol: 'circle',
              color: 'rgba(255, 255, 255, 0.24)',
              dashArrayX: [5, 8],
              dashArrayY: [5, 8],
            },
          ],
        },
      };
    }
    return {
      enabled: true,
      decal: {
        show: true,
        decals: [
          {
            symbol: 'none',
          },
          {
            symbol: 'rect',
            color: 'rgba(255, 255, 255, 0.12)',
            dashArrayX: [4, 16],
            dashArrayY: [1, 0],
            rotation: 45,
          },
        ],
      },
    };
  };

  // 判断数据源关键字段，判断是否属于同一源数据
  const isEqualSource = (item: any, indexObj: any) => {
    switch (item) {
      case 'appannie':
      case 'data.ai': {
        if (indexObj.source && ['annie', 'appannie', 'data.ai']?.includes(indexObj.source)) {
          return true;
        }
        return false;
      }
      case 'sensortower':
      case 'Sensor Tower': {
        if (indexObj.source && ['sensor', 'sensortower', 'Sensor Tower']?.includes(indexObj.source)) {
          return true;
        }
        return false;
      }
      case 'ogdb':
      case 'DataBrain': {
        if (indexObj.source && ['Databrain', 'databrain', 'brain', 'ogdb']?.includes(indexObj.source)) {
          return true;
        }
        return false;
      }
      default:
        return false;
    }
  };

  // 根据数据源数组，重新组装获取到的数据，同源的第一批数据
  const getBarEchartsCur = (arr: any, list: any) => {
    const newBarList: any = [];
    const listTemp = [...list];
    arr?.forEach((item: any) => {
      const firstList = Array.isArray(listTemp) && listTemp?.length > 0 ? listTemp[0] : [];
      const indexObj = Array.isArray(firstList) && firstList?.length > 0 ? firstList[0] : {};
      if (isEqualSource(item, indexObj)) {
        newBarList.push(firstList);
        listTemp.shift();
      } else {
        newBarList.push([]);
      }
    });
    return newBarList;
  };

  // 柱状图整合
  const handleEchart = (arr: any[]) => {
    // console.log('BarEchartsBarEcharts', BarEcharts);
    // console.log('axisRich', axisRich);
    let showData: {
      name: any;
      type: string;
      barGap: string;
      barWidth: number | null; // 柱图宽度
      data: any;
      label: {
        show: boolean;
        position: string;
        color: string;
        distance: number;
        fontSize: number;
        formatter: (params: any) => string;
      };
    }[] = [];
    // 重新组装数据源对应数据组
    const BarEchartsCur = getBarEchartsCur(arr, BarEcharts);
    arr?.map((item: any, index: any) => {
      showData?.push({
        name: topChartsType == 'databrain' ? `${item}databrain` : item, // 为避免粘花污染，给databrain加上特殊字符
        type: 'bar',
        barGap: '2%',
        barWidth: 60, // 柱图宽度
        // barWidth: BarEcharts[index]?.length < 6 ? 60 : null, //柱图宽度
        data: BarEchartsCur[index]?.map(
          (
            data: {
              url: any;
              name: any;
              barvalue: any;
              color: any;
              colorRight: any;
              colorThird: any;
            },
            idx: any,
          ) => {
            return {
              url: data.url,
              name: data.name,
              value: data.barvalue,
              itemStyle: {
                color: [data.color, data.colorRight, data.colorThird][index],
              },
            };
          },
        ),
        label: {
          show: true,
          position: 'top',
          color: '#444',
          distance: 4,
          fontSize: 12,
          formatter: (params: any) => {
            return `${formatNum(params.value, true, BarEchartsCur[index]?.length < 7 ? 2 : 0)}`;
          },
        },
      });
    });

    if (isStudio && gameHighId !== '' && showData?.length > 0) {
      const indexNum = lenten?.findIndex((item: any) => item?.game_id === gameHighId);
      if (indexNum >= 0) {
        showData = showData?.map((item: any) => {
          return {
            ...item,
            markArea: {
              data: [
                [
                  { xAxis: indexNum },
                  { xAxis: indexNum }, // 建议定义结束点
                ],
              ],
              itemStyle: {
                color: 'rgba(50, 111, 240, 0.08)',
                width: 2, // 显式声明宽度（可选）
              },
            },
          };
        });
      }
    }

    const option = {
      aria: getDecal(),
      grid: {
        // top: '10%',
        // bottom: '30%',
        // left: '55px',
        // right: '20px',
        left: '5px',
        right: '0px',
        // bottom: "45px",
        bottom: BAR_GRID_BOTTOM_WITH_RICH_IMG,
        containLabel: true,
        // top: "20px"
        top: BAR_GRID_TOP_WITH_LABEL,
      },
      title: {
        text: '',
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        padding: 0,
        borderWidth: 0,
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter(params: any[]) {
          return ChartBubble({
            data: params,
            titleNow,
            topChartsType,
            startDate,
            endDate,
          });
        },
        textStyle: {},
      },
      legend: {
        formatter(name: string) {
          return topChartsType == 'databrain' ? name?.replace('databrain', '') : name;
        },
        data: [
          {
            name: topChartsType == 'databrain' ? 'DataBrain' + 'databrain' : 'DataBrain',
            icon: DatabrainHuiEchartImg,
          },
          {
            name: topChartsType == 'databrain' ? 'data.ai' + 'databrain' : 'data.ai',
            icon: AnnieTiaoEchartImg,
          },
          {
            name: topChartsType == 'databrain' ? 'Sensor Tower' + 'databrain' : 'Sensor Tower',
            icon: isDataBrain ? SensorTowerDianEchartImg : SensorTowerNormalEchartImg,
          },
        ],
        selected: {
          'data.ai': false,
        },
        // bottom: '-5px',
        bottom: LEGEND_BOTTOM,
        width: '100%',
        itemWidth: 28,
        itemHeight: 16,
        itemGap: 20,
        textStyle: {
          color: '#888888',
          fontSize: 12,
        },
      },
      xAxis: {
        name: '',
        type: 'category',
        axisTick: {
          alignWithLabel: !isStudio,
        },
        // boundaryGap:  true,
        axisLabel: {
          interval: 0,
          overflow: 'truncate',
          ellipsis: '...',
          rich: {
            ...(axisRich || {}),
            boldB: {
              color: '#262832',
              fontSize: 12,
              fontWeight: 'bold',
            },
          },
          formatter(value: string | any[]) {
            let tempValue: any = '';
            if (value?.length > 16) {
              tempValue = `${value.slice(0, 10)}...`;
            }
            tempValue = value;
            const id = lenten?.find((item: { name: any }) => item.name === value)?.id;
            const isHighLine = gameHighId !== '' && id === gameHighId && isStudio;
            return [`{${id}|}\n\n{${isHighLine ? 'boldB' : 'avanametar'}|${tempValue}}`];
          },
          margin: 20,
        },
        data: showBarPeiName,
      },
      yAxis: [
        {
          axisLabel: {
            fontSize: 12,
            formatter: (value: number, _: any) => {
              if (props.pageid === 'Revenue') {
                // if (props.pageid === 'Revenue' && value >= maxData) {
                return `$${formatNum(value)}`;
              }
              return formatNum(value);
            },
            // color: '#BBBBBB',
            color: '#838697',
          },
          // max: function (value: { max: number }) {
          //   maxData = value.max;
          // },
          splitLine: {
            show: true,
            lineStyle: { color: '#E9E9E9', type: 'soild' },
          },
          axisLine: { show: false },
          axisTick: { show: false },
          type: 'value',
        },
        {
          show: true,
          type: 'value',
        },
      ],
      series: showData,
    };
    setBarOption(option);
    // console.log('option', option)
  };

  return {
    barOption,
    showBarPeiName,
  };
}
